export default __webpack_public_path__ + "static/nested-grid-light-a5b9134a92520b1a40c6ff2f8b3208f73cefbe72ad09cb883857d0311252faf1.png";